import React, { useState, useEffect } from "react";
import "./prixodrasxodgps.css";

const API = "/php";

const Prixodrasxodgps = ({ setChecked }) => {
    useEffect(() => { setChecked("3"); }, []);

    const currentMonth = new Date().getMonth() + 1;
    const [checkedMonth, setCheckedMonth] = useState(`${currentMonth}`);
    const [viewerlist, setviewerlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState("");
    const [prixodgps, setprixodgps] = useState("2");
    const [searchTerm, setSearchTerm] = useState("");
    const [searchImei, setsearchImei] = useState("");
    const [imei, setImei] = useState("");
    const [sn, setSn] = useState("");
    const [model, setModel] = useState("");

    // =============================================
    // Загрузка данных из MySQL
    // =============================================
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${API}/get_prixodrasxodgps.php?month=${checkedMonth}`);
                const data = await res.json();
                if (data.status === "success") setviewerlist(data.data);
                else { console.error(data.message); setviewerlist([]); }
            } catch (err) {
                console.error("Fetch error:", err);
                setviewerlist([]);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [checkedMonth]);

    // Активный месяц (CSS)
    useEffect(() => {
        for (let i = 1; i <= 12; i++) {
            const el = document.querySelector(`.abonentplata-month-span${i}`);
            if (el) el.classList.toggle("active", checkedMonth === String(i));
        }
    }, [checkedMonth]);

    // Активный фильтр (CSS)
    useEffect(() => {
        for (let i = 1; i <= 3; i++) {
            const el = document.querySelector(`.prixodgps-box1-filter-span${i}`);
            if (el) el.classList.toggle("active", prixodgps === String(i));
        }
    }, [prixodgps]);

    // Показать/скрыть форму добавления
    const toggleAddGps = () => {
        document.querySelector(".addGps")?.classList.toggle("active");
    };

    // =============================================
    // Добавление новой GPS записи
    // =============================================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!imei.trim() || !sn.trim() || !model.trim()) {
            alert("Заполните все поля");
            return;
        }
        try {
            const res = await fetch(`${API}/add_gps.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ imei, sn, model, month: checkedMonth })
            });
            const json = await res.json();
            if (json.ok) {
                setviewerlist(prev => [json.item, ...prev]);
                setImei(""); setSn(""); setModel("");
                toggleAddGps();
            } else {
                alert("Ошибка: " + (json.error || "unknown"));
            }
        } catch (err) {
            console.error(err);
            alert("Ошибка сети");
        }
    };

    // =============================================
    // Обновление users
    // =============================================
    const updateUsers = async (id, newusers) => {
        setviewerlist(prev => prev.map(item => item.id === id ? { ...item, users: newusers } : item));
        try {
            const res = await fetch(`${API}/add_gps.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, users: newusers, month: checkedMonth })
            });
            const result = await res.json();
            if (!result.ok) alert("Не удалось сохранить на сервере");
        } catch {
            alert("Ошибка соединения");
        }
    };

    // =============================================
    // Обновление unit (транспорт)
    // =============================================
    const updateTransport = async (id, newTrans) => {
        setviewerlist(prev => prev.map(item => item.id === id ? { ...item, unit: newTrans } : item));
        try {
            const res = await fetch(`${API}/add_gps.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, unit: newTrans, month: checkedMonth })
            });
            const result = await res.json();
            if (!result.ok) alert("Не удалось сохранить на сервере");
        } catch {
            alert("Ошибка соединения");
        }
    };

    const months = [
        ["1", "Январь"], ["2", "Февраль"], ["3", "Март"], ["4", "Апрель"],
        ["5", "Май"], ["6", "Июнь"], ["7", "Июль"], ["8", "Август"],
        ["9", "Сентябрь"], ["10", "Октябрь"], ["11", "Ноябрь"], ["12", "Декабрь"]
    ];

    return (
        <section className="prixodgps">
            <div className="prixod-flex">

                {/* ----- Месяцы ----- */}
                <div className="abonentplata-month">
                    <div className="abonentplata-month-h5">
                        <h5>{new Date().getFullYear()}</h5>
                    </div>
                    {months.map(([num, label]) => (
                        <span key={num}
                            className={`abonentplata-month-span abonentplata-month-span${num}`}
                            onClick={() => setCheckedMonth(num)}>
                            {label}
                        </span>
                    ))}
                </div>

                {/* ----- Форма добавления ----- */}
                <div className="addGps" onClick={toggleAddGps}>
                    <div className="addGps-flex" onClick={(e) => e.stopPropagation()}>
                        <span className="addGps-flex-box">
                            <h6>Модель:</h6>
                            <select value={model} onChange={(e) => setModel(e.target.value)}>
                                <option value="">Выберите....</option>
                                <option value="FMB920">FMB920</option>
                                <option value="FMB125">FMB125</option>
                                <option value="TD150">TD150</option>
                            </select>
                        </span>
                        <span className="addGps-flex-box">
                            <h6>IMEI:</h6>
                            <input value={imei} type="text" onChange={(e) => setImei(e.target.value)} />
                        </span>
                        <span className="addGps-flex-box">
                            <h6>S/N:</h6>
                            <input value={sn} type="text" onChange={(e) => setSn(e.target.value)} />
                        </span>
                        <div className="addGps-flex-box-button">
                            <button onClick={handleSubmit}>Оприходовать</button>
                        </div>
                    </div>
                </div>

                {/* ----- Основной блок ----- */}
                <div className="prixodgps-flex">
                    <div className="prixodgps-box1">
                        <div className="prixodgps-box1-filter">
                            <span className="prixodgps-box1-filter-span prixodgps-box1-filter-span1" onClick={() => setprixodgps("1")}>В наличии</span>
                            <span className="prixodgps-box1-filter-span prixodgps-box1-filter-span2" onClick={() => setprixodgps("2")}>Все</span>
                            <span className="prixodgps-box1-filter-span prixodgps-box1-filter-span3" onClick={() => setprixodgps("3")}>Проданные</span>
                        </div>
                        <div className="prixodgps-box1-filter2">
                            <h6>Модель:</h6>
                            <select value={selected} onChange={(e) => setSelected(e.target.value)}>
                                <option value="">Все</option>
                                <option value="FMB920">FMB920</option>
                                <option value="FMB125">FMB125</option>
                                <option value="TD150">TD150</option>
                            </select>
                        </div>
                        <div className="prixodgps-box1-filter3">
                            {["FMB920", "FMB125", "TD150"].map(m => (
                                <span key={m} className="prixodgps-box1-filter3box">
                                    <h6>{m}:</h6>
                                    <span>{(viewerlist || []).filter(i => i.model === m && !i.users).length}</span>
                                    <span>({(viewerlist || []).filter(i => i.model === m).length})</span>
                                </span>
                            ))}
                        </div>
                        <div className="abonentplata-search">
                            <span>
                                <h3><i className="fas fa-search"></i></h3>
                                <input type="text" placeholder="Учетная запись..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </span>
                        </div>
                        <div className="abonentplata-search">
                            <span>
                                <h3><i className="fas fa-search"></i></h3>
                                <input type="number" placeholder="IMEI..." value={searchImei} onChange={(e) => setsearchImei(e.target.value)} />
                            </span>
                        </div>
                        <div className="prixodgps-box1-addbutton" onClick={toggleAddGps}>+</div>
                    </div>

                    {/* ----- Таблица ----- */}
                    {loading ? <div className="loader"></div> : (
                        <table className="prixodgps-list-table">
                            <thead>
                                <tr className="prixodgps-list-table-sticky">
                                    <th>№</th>
                                    <th>Дата Прихода</th>
                                    <th>Модель</th>
                                    <th>IMEI</th>
                                    <th>S/N</th>
                                    <th>Учетная запись</th>
                                    <th>Транспорт</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(viewerlist || [])
                                    .sort((a, b) => b.id - a.id)
                                    .filter(koks => {
                                        const matchModel = (koks.model || "").toLowerCase().includes(selected.toLowerCase());
                                        const matchUser = (koks.users || "").toLowerCase().includes(searchTerm.toLowerCase());
                                        const matchImei = (koks.imei || "").toLowerCase().includes(searchImei.toLowerCase());
                                        let matchFilter = true;
                                        if (prixodgps === "1") matchFilter = !koks.users || koks.users.trim() === "";
                                        else if (prixodgps === "3") matchFilter = koks.users && koks.users.trim() !== "";
                                        return matchModel && matchUser && matchImei && matchFilter;
                                    })
                                    .map(koks => (
                                        <tr key={koks.id}
                                            style={{ backgroundColor: !koks.users || koks.users.trim() === "" ? "#ffe5e5" : "#96ebc556" }}>
                                            <td>{koks.id}</td>
                                            <td>{koks.date}</td>
                                            <td>{koks.model}</td>
                                            <td>{koks.imei}</td>
                                            <td>{koks.sn}</td>
                                            <td>
                                                {koks.model === "TD150"
                                                    ? <input type="text" placeholder="Введите значение" value={koks.users || ""} onChange={(e) => updateUsers(koks.id, e.target.value)} />
                                                    : koks.users ? koks.users : <input type="text" placeholder="Введите значение" value={koks.users || ""} onChange={(e) => updateUsers(koks.id, e.target.value)} />
                                                }
                                            </td>
                                            <td>
                                                {koks.model === "TD150"
                                                    ? <input type="text" placeholder="Введите значение" value={koks.unit || ""} onChange={(e) => updateTransport(koks.id, e.target.value)} />
                                                    : koks.unit
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Prixodrasxodgps;
